module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-16-lg relative border-left-right-blue",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "relative ind-1 full-span-outer overflow-hidden"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer"
  }, [_c('div', {
    staticClass: "full-span-inner content-translate",
    class: _vm.contentClass
  }, [_vm._t("default")], 2)])]), _vm._v(" "), (!_vm.nobg) ? _c('span-background', {
    attrs: {
      "full": "true"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5508b236"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/full_span_slide.vue
// module id = 625
// module chunks = 1